module.exports = __webpack_public_path__ + "static/feature-4-9d3a52028710c74c8c56738620ef77db.svg";